import { SelectOption } from '@globaleris/ui.library'
import {
  Buque,
  ConfigOperacionBalance,
  Destino,
  DispatchRequest,
  ElementoLogistico,
  EnumDispatchType,
  EnumEstadoViaje,
  EnumSubTipoElemLog,
  EnumTipoOperacion,
  SujetoEmisor,
  TravelRequest
} from '../../api'
import Ships, {
  Destiny,
  OriginPlant,
  ShipClient,
  ShipMarket,
  ShipOperation
} from '../../api/Pioneer/model/Ships'
import { enumKeyToValue, enumValueToKey } from '../../helpers'
import { getActiveBalanceZone } from '../../redux'
import ShipsModel, {
  BuqueModel,
  OperationBalanceConfiguration,
  OriginPlantModel,
  ShipClientModel,
  ShipMarketModel,
  ShipOperationModel,
  DestinyPlantModel
} from './ships.model'

export const shipsListItemsMapper = (items: Ships[]): ShipsModel[] => {
  return items && items.map(shipsListItemMapper)
}

export const shipsListItemMapper = (item: Ships): ShipsModel => {
  return (
    item && {
      id: item.id,
      tripDate: item.tripDate,
      code: item.code,
      tsoCode: item.tsoCode,
      ship: shipItemMapper(item.ship),
      operationType: enumKeyToValue(EnumTipoOperacion, item.operationType),
      originPlant: originPlantItemMapper(item.originPlant),
      destinationsIds: item.destinations.map(item => item.destinyPlant.description),
      destinations: shipsDestinationOptionMapper(item.destinations),
      quantity: item.quantity,
      share: item.share,
      soe: item.soe,
      tripState: enumKeyToValue(EnumEstadoViaje, item.tripState),
      owner: ownerItemMapper(item.owner),
      marketersIds: item.marketers.map(item => item.description),
      marketers: shipsMarketersOptionMapper(item.marketers),
      shipOperations: listShipOperationsMapper(item.shipOperations)
    }
  )
}

export const shipsListItemMapperEdit = (item: Ships): ShipsModel => {
  return (
    item && {
      id: item.id,
      tripDate: item.tripDate,
      code: item.code,
      tsoCode: item.tsoCode,
      ship: shipItemMapper(item.ship),
      operationType: enumKeyToValue(EnumTipoOperacion, item.operationType),
      originPlant: originPlantItemMapper(item.originPlant),
      destinationsIds: item.destinations.map(item => item.destinyPlant.id),
      destinations: shipsDestinationOptionMapper(item.destinations),
      quantity: item.quantity,
      share: item.share,
      soe: item.soe,
      tripState: enumKeyToValue(EnumEstadoViaje, item.tripState),
      owner: ownerItemMapper(item.owner),
      marketersIds: item.marketers.map(item => item.id),
      marketers: shipsMarketersOptionMapper(item.marketers),
      shipOperations: listShipOperationsMapper(item.shipOperations)
    }
  )
}

export const shipItemMapper = (item: Buque): BuqueModel => {
  return (
    item && {
      id: item.id,
      description: item.description,
      capacity: item.capacity
    }
  )
}

export const originPlantItemMapper = (item: OriginPlant): OriginPlantModel => {
  return (
    item && {
      id: item.id,
      description: item.description
    }
  )
}

export const ownerItemMapper = (item: ShipClient): ShipClientModel => {
  return (
    item && {
      id: item.id,
      description: item.description
    }
  )
}

export const listMarketersMapper = (items: ShipMarket[]): ShipMarketModel[] => {
  return items && items.map(marketersItemMapper)
}

export const marketersItemMapper = (item: ShipMarket): ShipMarketModel => {
  return (
    item && {
      description: item.description,
      id: item.id
    }
  )
}

export const listShipOperationsMapper = (items: ShipOperation[]): ShipOperationModel[] => {
  return items && items.map(shipOperationsItemMapper)
}

export const shipOperationsItemMapper = (item: ShipOperation): ShipOperationModel => {
  return (
    item && {
      operationId: item.operationId,
      operationDate: item.operationDate,
      operationQuantity: item.operationQuantity,
      operationSentQuantity: item.operationSentQuantity,
      operationTsoQuantity: item.operationTsoQuantity,
      operationElemLogId: item.operationElemLogId,
      operationElemLogDescription: item.operationElemLogDescription,
      operationState: item.operationState
    }
  )
}

export const shipsDestinationOptionMapper = (items: Destiny[]): DestinyPlantModel[] => {
  return items && items.map(destinyItemMapper)
}

export const destinyItemMapper = (item: Destiny): DestinyPlantModel => {
  return (
    item && {
      id: item.destinyPlant.id,
      description: item.destinyPlant.description
    }
  )
}

export const shipsMarketersOptionMapper = (items: ShipMarket[]): ShipMarketModel[] => {
  return items && items.map(marketersItemMapperEdit)
}

export const marketersItemMapperEdit = (item: ShipMarket): ShipMarketModel => {
  return (
    item && {
      id: item.id,
      description: item.description
    }
  )
}

//#region old

export const shipsSelectOptionMapper = (data: ShipsModel): SelectOption[] => {
  return [{ value: data.ship.id, label: data.ship.description }]
}

export const ownerSelectOptionMapper = (data: ShipsModel): SelectOption[] => {
  return [{ value: data.owner.id, label: data.owner.description }]
}

export const marketerSelectOptionMapper = (data: ShipsModel): SelectOption[] => {
  let marketersOptions : any[] = []
  data.marketers.forEach(element => {
    marketersOptions.push({ value: element.id, label: element.description })
  });
  return marketersOptions
}

export const destinationsSelectOptionMapper = (data: ShipsModel): SelectOption[] => {
  let destinationsOptions : any[] = []
  data.destinations.forEach(element => {
    destinationsOptions.push({ value: element.id, label: element.description })
  });
  return destinationsOptions
}

export const commercialPlantSelectOptionMapper = (data: ShipsModel): SelectOption[] => {
  let commercialPlantsOptions : any[] = []
  data.shipOperations.forEach(element => {
    commercialPlantsOptions.push({ value: element.operationElemLogId, label: element.operationElemLogDescription })
  });
  return commercialPlantsOptions
}

export const subjectsSelectOptionMapper = (subjects: any): SelectOption[] => {
  return subjects.map(subject => {
    return { value: subject.id, label: subject.deSujeto }
  })
}

export const travelPostMapper = (travel: any): TravelRequest => {
  return (
    travel && {
      fechaViaje: travel.date,
      cantidad: travel.quantity,
      compartido: travel.share ? travel.share : false,
      soe: travel.soe ? travel.soe : false,
      tipoOperacion: enumValueToKey(EnumTipoOperacion, travel.typeFilter),
      estado: enumValueToKey(EnumEstadoViaje, EnumEstadoViaje.Pendiente),
      buque: {
        '@odata.id': 'buques(' + travel.ship + ')'
      },
      plantaOrigen: {
        '@odata.id': 'elementoslogisticos(' + travel.origin + ')'
      },
      destinos: destinationsPostMapper(travel.destination),
      comercializadores: marketersPostMapper(travel.marketers)
      // propietario: {
      //   '@odata.id': 'sujetos(' + travel.property + ')'
      // }

      // operaciones?: Operacion[];
    }
  )
}

const destinationsPostMapper = (destinations: Destino[]): any => {
  let returnDestinations: any[] = []

  destinations.forEach(destination => {
    returnDestinations.push({
      plantaDestino: {
        '@odata.id': 'elementoslogisticos(' + destination + ')'
      }
    })
  })

  return returnDestinations
}

// const destinationsPatchMapper = (destinations: any[] | undefined): any => {
//   let returnDestinations: any[] = [];

//   destinations?.forEach(destination => {
//     returnDestinations.push({
//       plantaDestino: {
//         '@odata.id': 'elementoslogisticos(' + destination + ')'
//       },
//       porcentaje: 100
//     });
//   });

//   return returnDestinations;
// };

const marketersPostMapper = (marketers: SujetoEmisor[]): any => {
  let returnMarketers: any[] = []

  marketers.forEach(marketer => {
    returnMarketers.push({
      comercializador: {
        '@odata.id': 'sujetos(' + marketer + ')'
      }
    })
  })

  return returnMarketers
}

// const marketersPatchMapper = (marketers: any[] | undefined): any => {
//   let returnMarketers: any[] = [];

//   marketers?.forEach(marketer => {
//     returnMarketers.push({
//       comercializador: {
//         '@odata.id': 'sujetos(' + marketer + ')'
//       }
//     });
//   });

//   return returnMarketers;
// };

export const logisticElementsMapperToDropDown = (items: ElementoLogistico[]): SelectOption[] => {
  return items && items.map(logisticElementMapperToDropDown)
}

export const logisticElementMapperToDropDown = (item: ElementoLogistico): SelectOption => {
  return (
    item && {
      value: item.id,
      label: item.descripcion || ''
    }
  )
}

export const operationBalanceConfigMapperAPItoModel = (
  item: ConfigOperacionBalance
): OperationBalanceConfiguration => {
  return (
    item && {
      operationType: enumKeyToValue(EnumTipoOperacion, item.tipoOperacion),
      logisticElementSubType: enumKeyToValue(EnumSubTipoElemLog, item.subtipoElementoLogistico)
    }
  )
}

export const operationsBalanceConfigMapperAPItoModel = (
  items: ConfigOperacionBalance[]
): OperationBalanceConfiguration[] => {
  return items && items.map(operationBalanceConfigMapperAPItoModel)
}

export const travelSendMapper = (items: any[], idCompany: number): DispatchRequest => {
  return (
    items && {
      dispatchType: enumKeyToValue(EnumDispatchType, EnumDispatchType.Nominacion),
      companyID: idCompany,
      operations: items.map(item => {
        return {
          id: item.id,
          operationType: item.operationType,
          balanceZone: getActiveBalanceZone()?.code!
        }
      })
    }
  )
}
//#endregion
